import { GameIcon } from "./casino-contents";
import * as I from "../../utils/icons";
import { useMemo, useState } from "preact/hooks";
import {
    CasinoRetriever, CasinoWidget, 
    useFilteredGamesList
} from "./logic";
import { Trans } from "@lingui/react/macro";

// Mostra i giochi in una griglia da 6 oppure 8 colonne (desktop, in base alla larghezza schermo), 3 da mobile, 4 da tablet
// Carica i giochi in chunk da 50, solo quando l'utente è prossimo al termine della pagina
export function InfiniteScrollPage({ games, currentPage, mainPage }: { games: CasinoRetriever, currentPage: CasinoWidget, mainPage: string }) {
    const allGames = useFilteredGamesList(currentPage, games);
    const [visibleCount, setVisibleCount] = useState(50);
    const displayedGames = useMemo(() => allGames.slice(0, visibleCount), [allGames, visibleCount]);

    const loadMore = () => {
        setVisibleCount(prevCount => prevCount + 50);
    };

    return (
        <div class="">
            <div class="flex items-center justify-between px-4 py-2">
                <a href={`/${mainPage}`} class="flex items-center gap-2">
                    <I.AnglesLeft class="h-4" />
                    <span class="text-lg">{currentPage.data.name}</span>
                </a>
            </div>
            <div class="grid grid-cols-3 md:grid-gols-7 xl:grid-cols-8 gap-2 px-2">
                {displayedGames.map((game) => (
                    <GameIcon game={game} />
                ))}
            </div>
            {visibleCount < allGames.length && (
                <div class="flex justify-center py-4">
                    <div class="text-center">
                        <div class="w-64 h-2 bg-slate-700 rounded-full mb-2">
                            <div class="h-2 bg-sky-500 rounded-full" style={{ width: `${(visibleCount / allGames.length) * 100}%` }}></div>
                        </div>
                        <div class="text-sm text-slate-400 mb-2">
                            <Trans>You've loaded {visibleCount} games from {allGames.length}</Trans>
                        </div>
                        <button onClick={loadMore} class="mx-auto bg-yellow-500 text-black font-bold py-2 px-4 rounded-full flex items-center gap-2">
                            <Trans>Load More</Trans> <I.RefreshIcon class="h-4" />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

// Per ora non serve
export function ProvidersPage({ providersList }) {
    // lista provider della pagina più esterna
}
